export default "__VITE_ASSET__CVGHLgml__"